import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  List,
  ListItem,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Text,
  Box,
} from '@chakra-ui/react';

const VirtualTagSelectorModal = ({
  isOpen,
  onClose,
  virtualTags,
  onSelect,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Select a Virtual Tag</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {virtualTags.length === 0 ? (
            <Text>No virtual tags available</Text>
          ) : (
            <Accordion allowToggle>
              {virtualTags.map((deviceGroup, index) =>
                deviceGroup.device.map(
                  device =>
                    device.tag.length > 0 && (
                      <AccordionItem key={device.uuid}>
                        <AccordionButton>
                          <Box flex="1" textAlign="left">
                            {device.name}
                          </Box>
                          <AccordionIcon />
                        </AccordionButton>
                        <AccordionPanel>
                          <List spacing={2}>
                            {device.tag.map(tag => (
                              <ListItem
                                key={tag.id}
                                cursor="pointer"
                                p={2}
                                _hover={{ bg: 'gray.100' }}
                                borderRadius="md"
                                onClick={() => onSelect(tag)}
                              >
                                {tag.name}
                              </ListItem>
                            ))}
                          </List>
                        </AccordionPanel>
                      </AccordionItem>
                    )
                )
              )}
            </Accordion>
          )}
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" onClick={onClose}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default VirtualTagSelectorModal;
